exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input#last_service_date:disabled {\n  color: #F44336;\n}", ""]);

// exports
